import { createIcon } from './createIcon'

export const CompleteIcon = createIcon({
  displayName: 'CompleteIcon',
  viewBox: '0 0 22 22',
  path: [
    <g id="Notifications-toast-success" clipPath="url(#clip0_402_3634)">
      <g id="Group 626876">
        <g id="Group 626877">
          <path
            id="Vector"
            d="M11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20Z"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="transparent"
          />
          <path
            id="Vector_2"
            d="M15.0113 8.38403L10.6538 14.1935C10.5568 14.3223 10.4334 14.4288 10.2919 14.5058C10.1503 14.5829 9.99392 14.6287 9.83317 14.6402C9.67241 14.6518 9.51106 14.6287 9.35997 14.5726C9.20888 14.5165 9.07157 14.4287 8.95728 14.315L6.70728 12.065"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="transparent"
          />
        </g>
      </g>
    </g>,
  ],
})
